"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var TotalBalanceLabel_1 = tslib_1.__importDefault(require("../TotalBalanceLabel"));
var TotalBalanceAmt_1 = tslib_1.__importDefault(require("../TotalBalanceAmt"));
var CreditAccountBalance = function (_a) {
    var totalBalance = _a.totalBalance;
    return (react_1.default.createElement(asg_1.Box, { direction: "row" },
        react_1.default.createElement(asg_1.Box, { width: "35%", alignSelf: "start" },
            react_1.default.createElement(TotalBalanceLabel_1.default, null)),
        react_1.default.createElement(asg_1.Box, { width: "65%", direction: "row" },
            react_1.default.createElement(asg_1.Box, { width: "100%" },
                react_1.default.createElement(TotalBalanceAmt_1.default, { totalBalance: totalBalance })),
            react_1.default.createElement(asg_1.Box, { width: "65px", alignSelf: "end" },
                react_1.default.createElement(asg_1.Text, { size: "small", weight: 600, textAlign: "end", "data-testid": "creditLabel", pad: { left: '10px' }, lineHeight: "24px" }, "Credit")))));
};
exports.default = CreditAccountBalance;
//# sourceMappingURL=CreditAccountBalance.js.map